import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { tx } from "@/i18n";

export const GuestMessagesToggle = () => {
  const [enabled, setEnabled] = useState(null);
  useEffect(() => { api.get("/settings/guest-messages").then(({ data }) => setEnabled(data.enabled)).catch(() => {}); }, []);
  if (enabled === null) return null;
  const change = async (v) => {
    setEnabled(v);
    try {
      await api.put("/settings/guest-messages", { enabled: v });
      toast.success(v ? tx("Automatische gastberichten staan AAN") : tx("Automatische gastberichten staan UIT"));
    } catch (err) { setEnabled(!v); toast.error(apiError(err)); }
  };
  return (
    <label className={`flex items-center gap-2.5 px-3 py-2 rounded-lg border text-sm cursor-pointer ${enabled ? "border-secondary/40 bg-secondary/10" : "border-amber-300 bg-amber-50"}`} data-testid="guest-messages-toggle">
      <Mail className="h-4 w-4 shrink-0" />
      <span className="font-medium">{tx("Automatische gastberichten")}</span>
      <Switch checked={enabled} onCheckedChange={change} data-testid="guest-messages-switch" />
      <span className="text-xs font-semibold" data-testid="guest-messages-status">{enabled ? tx("AAN") : tx("UIT")}</span>
    </label>
  );
};
